/// <amd-module name="TFS/Admin/Groups/Common/Util/CommonTypeConverters" />

import { IdentityRef, TeamMember } from "VSS/Platform/Contracts/WebApi";

import { GraphMember } from "VSS/Platform/Contracts/Graph";
import { IEntityType } from "TFS/Admin/Groups/Common/Constants";
import { IIdentity } from "VSS/Features/Identities/IdentityService";
import { IVssPageContext } from "VSS/Platform/Context";
import { SelectableGraphMember } from "TFS/Admin/Groups/Common/Contracts";
import { getIdentityImageUrl } from "VSS/Platform/Identity";

export function getIdentityImage(pageContext: IVssPageContext, descriptor: string, avoidCache: boolean) {
    return getIdentityImageUrl(pageContext, { descriptor: descriptor } as IdentityRef) + (avoidCache ? `?${new Date().getTime()}` : "");
}

export function convertSelectableGraphMemberToIIdentity(
    pageContext: IVssPageContext,
    selectableGraphMember: SelectableGraphMember,
    avoidCache: boolean = false
): IIdentity {
    if (!selectableGraphMember) {
        return {} as IIdentity;
    }

    let identityImageUrl = selectableGraphMember.descriptor ? getIdentityImage(pageContext, selectableGraphMember.descriptor, avoidCache) : "";

    return {
        localId: selectableGraphMember.originId,
        originId: selectableGraphMember.originId,
        originDirectory: selectableGraphMember.origin,
        displayName: selectableGraphMember.displayName,
        image: identityImageUrl,
        subjectDescriptor: selectableGraphMember.descriptor,
        mail: selectableGraphMember.mailAddress,
        entityId: selectableGraphMember.entityId,
        entityType: selectableGraphMember.entityType
    } as IIdentity;
}

export function convertGraphMemberToIIdentity(pageContext: IVssPageContext, graphMember: GraphMember, avoidCache: boolean = false): IIdentity {
    if (!graphMember) {
        return {} as IIdentity;
    }

    let identityImageUrl = graphMember.descriptor ? getIdentityImage(pageContext, graphMember.descriptor, avoidCache) : "";

    return {
        localId: graphMember.originId,
        originId: graphMember.originId,
        displayName: graphMember.displayName,
        image: identityImageUrl,
        subjectDescriptor: graphMember.descriptor,
        entityType: graphMember.subjectKind
    } as IIdentity;
}

export function convertIdentityRefToGraphMember(member: TeamMember): SelectableGraphMember {
    if (!member) {
        return {} as SelectableGraphMember;
    }
    const { identity } = member;
    return ({
        ...identity,
        isAdmin: member.isTeamAdmin,
        subjectKind: identity.isContainer ? IEntityType.Group : IEntityType.User,
        principalName: identity.displayName,
        displayName: identity.displayName.substring(identity.displayName.indexOf("\\") + 1),
        mailAddress: identity.isContainer ? undefined : identity.uniqueName
    } as unknown) as SelectableGraphMember;
}
